import React, {useEffect, useState} from 'react'
import {
  getConfigurationByName,
  updateConfigurationByConfigID,
} from '../../../../../../API/api-endpoint'
import ToastUtils, {ErrorToastUtils} from '../../../../../../utils/ToastUtils'

const RewardPlugin = () => {
  const [configID, setConfigId] = useState(0)
  const [rewardConfig, setRewardConfig] = useState<any>({
    initialOffer: 200,
    isEnableRewards: true,
  })

  useEffect(() => {
    getConfiguration()
  }, [])

  const handleChange = (event: any) => {
    let name = event.target.name
    let value = event.target.checked

    if (name !== 'isEnableRewards') {
      setRewardConfig({...rewardConfig, [name]: event.target.value})
    } else {
      setRewardConfig({...rewardConfig, [name]: value})
      updateConfiguration({...rewardConfig, [name]: value})
    }
  }

  const getConfiguration = async () => {
    let result = await getConfigurationByName('rewards')
    if (result.success) {
      // let parsedData = JSON.parse(result.data.values)
      let parsedData = result.data.values
      setConfigId(result.data._id)
      setRewardConfig({
        initialOffer: parsedData?.initialOffer,
        isEnableRewards: parsedData?.isEnableRewards,
      })
    }
  }

  const updateConfiguration = async (config: any) => {
    let result = await updateConfigurationByConfigID(configID, config, null)
    if (result.success) {
      getConfiguration()
      ToastUtils({type: 'success', message: 'Configuration Saved SuccessFully'})
    } else {
      ErrorToastUtils()
    }
  }

  const onBlurUpdate = () => {
    updateConfiguration(rewardConfig)
  }

  return (
    <div className='card'>
      <div className='card-title p-8'>
        <h2>Reward settings</h2>
      </div>
      <div className='card-body'>
        <div className='row no-gutters'>
          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Enable Rewards plugin</strong>
            </p>
            <p className='text-muted'>Enable or disable Rewards plugin</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='flexSwitchCheckDefault'
                name='isEnableRewards'
                checked={rewardConfig.isEnableRewards}
                onChange={(event) => handleChange(event)}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>New accounts free Offers</strong>
            </p>
            <p className='text-muted'>Give some free Offers to new account users</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex'>
              <input
                type='number'
                className='form-control'
                name='initialOffer'
                value={rewardConfig.initialOffer}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RewardPlugin
